var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle pos-rel w60px w50px-mb",class:_vm.state ? 'active' : '',on:{"click":_vm.toggle}},[_c('div',{staticClass:"draggable pos-abs bg-violet",style:(_vm.style)})])}
var staticRenderFns = []

export { render, staticRenderFns }